import { i18nFactory } from '@lib/i18n';

const ru = {
    GE: 'Грузия',
    BTM: 'Батуми',
    bath: 'Ванна',
    shower: 'Душ',
    country: 'Страна',
    city: 'Город',
    typeApartment: 'Тип квартиры',
    studio: 'Студия',
    apartment1room: '1-к квартира',
    apartment2room: '2-к квартира',
    apartment3room: '3-к квартира',
    apartment4room: '4-к квартира',
    house: 'Дом',
    address: 'Адрес',
    floor: 'этаж',
    square: 'Площадь',
    price: 'Цена',
    oven: 'Духовка',
    dishwasher: 'Посудомойка',
    balcony: 'Балкон',
    animal: 'Можно с животными',
    conditioner: 'Кондиционер',
    microwave: 'Микроволновка',
    perMonth: 'в месяц',
};

const en = {
    GE: 'Грузия',
    BTM: 'Батуми',
    bath: 'Bath',
    shower: 'Shower',
    studio: 'Studio apartment',
    apartment1room: '1 room apartment',
    apartment2room: '2 room apartment',
    apartment3room: '3 room apartment',
    apartment4room: '4 room apartment',
    house: 'House',
    country: 'Страна',
    city: 'Город',
    typeApartment: 'Тип квартиры',
    address: 'Адрес',
    floor: 'этаж',
    square: 'Площадь',
    price: 'Цена',
    oven: 'Духовка',
    dishwasher: 'Посудомойка',
    balcony: 'Балкон',
    animal: 'Можно с животными',
    conditioner: 'Кондиционер',
    microwave: 'Микроволновка',
    perMonth: 'per month',
};

const ka = {
    GE: 'საქართველო',
    BTM: 'ბათუმი',
    bath: 'აბაზანა',
    shower: 'შხაპი',
    studio: 'სტუდიო ბინა',
    apartment1room: 'სტუდიო ბინა',
    apartment2room: 'ერთოთახიანი ბინა',
    apartment3room: 'ოროთახიანი ბინა',
    apartment4room: 'ოთხოთახიანი ბინა',
    house: 'სახლი',
    country: 'Страна',
    city: 'Город',
    typeApartment: 'Тип квартиры',
    address: 'Адрес',
    floor: 'этаж',
    square: 'Площадь',
    price: 'Цена',
    oven: 'Духовка',
    dishwasher: 'Посудомойка',
    balcony: 'Балкон',
    animal: 'Можно с животными',
    conditioner: 'Кондиционер',
    microwave: 'Микроволновка',
    perMonth: 'თვეში',
};

export const i18n = i18nFactory({ ru, en, ka });
